import { Box, Tooltip, Typography } from "@mui/material";
import React from "react";

import TruncatedText from "../../full-time-shifts/ui/weekly-shift-view/truncated-text";
import Highlight from "../../Highlight";

interface ColumnCellProps {
    text: string | number;
    searchText?: string;
}

const ColumnCell: React.FC<ColumnCellProps> = ({ text, searchText }) => {
    const displayText = text ?? "-";

    return (
        <TruncatedText 
            text={String(displayText)}
            searchedTerm={searchText}
            style={{
                fontFamily: "Roboto",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "20px",
                color: "#1C1B1F",
                width: "100%",
                paddingLeft: "16px",
                boxSizing: "border-box",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            }}
        />
    );
};

export default ColumnCell;
